{
  "panel": {
    "title": "Plan",
    "trackerTitle": "Suivi du plan",
    "loading": "Chargement du plan...",
    "empty": "Aucun plan pour le moment.",
    "emptyTitle": "Aucun plan pour le moment",
    "emptyHint": "Importez une description de tâche pour générer un plan.",
    "loadFailed": "Impossible de charger le plan."
  },
  "generation": {
    "starting": "Démarrage de la génération du plan...",
    "structure": "Construction de la structure du plan...",
    "enrichment": "Enrichissement des éléments du plan...",
    "stage": "Étape {{stage}} sur {{total}}",
    "itemsEnriched": "{{enriched}} sur {{total}} éléments enrichis",
    "complete": "Plan généré.",
    "failed": "Échec de la génération du plan.",
    "errorContact": "Échec de la génération du plan. Veuillez réessayer.",
    "regenerate": "Régénérer le plan",
    "regenerating": "Régénération du plan...",
    "abort": "Interrompre",
    "aborting": "Interruption..."
  },
  "review": {
    "title": "Examiner le plan",
    "subtitle": "Approuvez, modifiez ou demandez des changements au plan avant de générer le rapport.",
    "approve": "Approuver le plan",
    "approveAndGenerate": "Approuver et générer le rapport",
    "approving": "Approbation...",
    "approveFailed": "Impossible d'approuver le plan.",
    "requestChanges": "Demander des changements",
    "feedbackTitle": "Retour sur le plan",
    "feedbackPlaceholder": "Décrivez ce qui doit changer dans le plan.",
    "feedbackSubmit": "Envoyer le retour",
    "feedbackSubmitting": "Envoi...",
    "feedbackEmpty": "Veuillez d'abord décrire vos changements.",
    "feedbackSent": "Retour reçu. Mise à jour du plan...",
    "approveItem": "Approuver l'élément",
    "rejectItem": "Rejeter l'élément",
    "approveAllItems": "Tout approuver",
    "rejectAllItems": "Tout rejeter",
    "addItem": "Ajouter un élément",
    "deleteItem": "Supprimer l'élément",
    "moveUp": "Déplacer vers le haut",
    "moveDown": "Déplacer vers le bas",
    "indent": "Indenter",
    "outdent": "Désindenter"
  },
  "item": {
    "untitled": "Section sans titre",
    "noDescription": "Aucune description.",
    "edit": "Modifier",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "saving": "Enregistrement...",
    "saveFailed": "Impossible d'enregistrer les modifications.",
    "titleLabel": "Titre",
    "descriptionLabel": "Description",
    "methodologyLabel": "Méthodologie",
    "dataRequirementsLabel": "Données requises",
    "outputFormatLabel": "Format de sortie",
    "qualityCriteriaLabel": "Critères de qualité",
    "expand": "Développer",
    "collapse": "Réduire",
    "viewDetails": "Voir les détails",
    "rejected": "Rejeté",
    "approved": "Approuvé",
    "pending": "En attente de révision"
  },
  "actions": {
    "approveAndStartReport": "Approuver le plan et lancer le rapport",
    "abortAndRevise": "Interrompre et réviser",
    "duplicate": "Dupliquer"
  },
  "progress": {
    "buildingYourPlan": "Élaboration de votre plan",
    "inProgress": "Génération du plan en cours...",
    "stepPlanning": "Génération de la structure du plan",
    "stepEnriching": "Enrichissement des détails de section",
    "generatingStructure": "Génération de la structure du plan...",
    "analyzing": "Analyse...",
    "finalizing": "Finalisation de la structure du plan...",
    "enrichingDetails": "Enrichissement des détails de section...",
    "noPlan": "Aucun plan disponible",
    "feedbackApplied": "Plan mis à jour avec votre retour",
    "feedbackRefreshFailed": "Échec de l'actualisation du plan après le retour",
    "feedbackUpdateFailed": "Échec de la mise à jour du plan"
  }
}
